import { AppDataSync } from '@conexasaude/analytics'
import { useMemo } from 'react'
import { IS_PRODUCTION } from '@/constants'
import { User } from '@/modules/Auth/classes/User'
import { useLocation } from 'react-router-dom'
import * as device from 'react-device-detect'

export const useAnalyticsData = (user?: User) => {
  const { pathname } = useLocation()

  const userDevice = useMemo(() => {
    return device.isMobile ? 'mobile' : 'desktop'
  }, [])

  const analyticsDataSync: AppDataSync = useMemo(
    () => ({
      pathname,
      devEnvironment: !IS_PRODUCTION,
      user: {
        analyticsUserId: user?.cpf,
        id: user?.id,
        patientId: user?.patientId,
        firstName: user?.firstName,
        lastName: user?.lastName,
        clinic: {
          id: user?.clinic?.id,
          name: user?.clinic?.name,
        },
      },
      userVariant: 'paciente',
      gtag: {
        default: true,
        trackingId: import.meta.env.VITE_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID,
      },
      gtm: {
        default: true,
        trackingId: import.meta.env.VITE_APP_TAG_MANAGER_ID,
        ...(user && {
          customUserProperties: {
            user_id: user?.id?.toString(),
            email: user?.email,
            cellphone: user?.cellphone,
          },
        }),
      },
      clarity: {
        default: true,
        enabled: IS_PRODUCTION,
        trackingId: import.meta.env.VITE_APP_CLARITY_ID,
      },
      maze: {
        default: true,
        trackingId: import.meta.env.VITE_APP_MAZE_API_KEY,
      },
      usetiful: {
        default: true,
        trackingId: import.meta.env.VITE_APP_USETIFUL_API_KEY,
        userData: {
          userId: user?.id.toString(),
          firstName: user?.firstName,
          lastName: user?.lastName,
          clinicId: user?.clinic?.id.toString(),
          biologicalGender: user?.sex,
          device: userDevice,
          age: user?.age.toString(),
        },
      },
    }),
    [pathname, user, userDevice],
  )

  return analyticsDataSync
}
